import { render, staticRenderFns } from "./NoDataMessage.vue?vue&type=template&id=6e7dc302&scoped=true&"
import script from "./NoDataMessage.vue?vue&type=script&lang=js&"
export * from "./NoDataMessage.vue?vue&type=script&lang=js&"
import style0 from "./NoDataMessage.vue?vue&type=style&index=0&id=6e7dc302&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7dc302",
  null
  
)

export default component.exports